import { DRAWING_TYPES } from './drawable-types'

export const DRAWING_TYPE_SIZE_VALIDATIONS = {
    [DRAWING_TYPES.AREA]: {
        measurement: 'area',
        minValue: 0.083 * 0.083,
    },
    [DRAWING_TYPES.SECTION]: {
        measurement: 'linear_total',
        minValue: 0.083,
    },
    [DRAWING_TYPES.RADIUS]: {
        measurement: 'linear_total',
        minValue: 0.083,
    },
}

export const TOOLBAR_GROUPING_BREAKPOINT = 1600

// Flag dialog constants
export const DEFAULT_DIALOG_HEIGHT = 500
export const FLAG_POPUP_DISTANCE = 20
export const FLAG_POPUP_WIDTH = 340
export const QRM_PANEL_WIDTH_VW = 18
export const TOOLBAR_HEIGHT = 40
export const EFFECTIVE_BOTTOM_BOUNDARY_OFFSET = 5
export const VW_DIVISOR = 100
